import { Pipe, PipeTransform } from '@angular/core';

/**
 * asterisk pipe
 *
 * Usage in the template file:
 * {{ 'my.key' | translate | asterisk }}
 *
 */
@Pipe({
    name: 'asterisk',
    standalone: false
})
export class AsteriskPipe implements PipeTransform {
    /**
     *
     * @param string The string to append
     *
     * @returns appended string with asterisk added
     */
    transform(key: string): string {
        return `${key}*`;
    }
}
